

import { createSlice } from '@reduxjs/toolkit';
import { Competition } from '@brg/api';

export interface CompetitionActionPanelSliceStates {
    currentCompetition?: Competition;
    legalContestDeferFormPublishCompetitionId?: string | null;
    projectIsValid?: boolean;
    projectErrors?: string[];
}

export const CompetitionActionPanel = createSlice({
    name: 'competitionActionPanel',
    initialState: {
        currentCompetition: {
            competitionId: '',
            requredTagIds: ['5164b991a9d8469389175ceeb86d65b8'],
        },
        // currentCompetition: 'eaf67300718c482cb9e4abfff21f9a4b',
        // // // currentCompetition: null,
        // requiredTagIds: ["dddca0c7066a492a9ea553aca554ab7c",
        //     "2687fadaf0e048ed9925e56052f3010e",
        //     "5164b991a9d8469389175ceeb86d65b8", "47ae888ae5fe4343ad29999d04829b44", "9042e2d03e4e490b8c7effb0d2334cc4", "df140c74barqwe1e3d883a590378812d77"],
        // nominationId: '644035972eb44dcfa1818c464b940c9d',
        projectIsValid: false,
        projectErrors: [],
        legalContestDeferFormPublishCompetitionId: undefined,
    },
    reducers: {
        setCurrentCompetition: (state, action) => {
            state.currentCompetition = action.payload;
        },
        resetCurrentCompetition: (state) => {
            state.currentCompetition = undefined;
            state.legalContestDeferFormPublishCompetitionId = undefined;
        },
        setLegalContestDeferFormPublishCompetitionId: (state, action: { payload: string | undefined | null }) => {
            state.legalContestDeferFormPublishCompetitionId = action.payload ?? undefined;
        },
        setProjectValidity: (state, action) => {
            state.projectIsValid = action.payload.projectIsValid;
            state.projectErrors = action.payload.projectErrors;
        },
        resetProjectValidity: (state) => {
            state.projectIsValid = false;
            state.projectErrors = [];
        },
    },
});

export default CompetitionActionPanel
export const CompetitionActionPanelActions = CompetitionActionPanel.actions
export const ActiveCompetitionSelector = (
    store: { competitionActionPanel: CompetitionActionPanelSliceStates },
): Competition | undefined => store.competitionActionPanel.currentCompetition;

export const LegalContestDeferFormPublishCompetitionIdSelector = (store: {
    competitionActionPanel: CompetitionActionPanelSliceStates;
}): string | undefined | null => store.competitionActionPanel.legalContestDeferFormPublishCompetitionId;
export const ProjectValiditySelector = (store: { competitionActionPanel: CompetitionActionPanelSliceStates }): any => ({
    projectIsValid: store.competitionActionPanel.projectIsValid,
    projectErrors: store.competitionActionPanel.projectErrors,
});
export const CompetitionActionPanelSelector = (store: { competitionActionPanel: CompetitionActionPanelSliceStates }): CompetitionActionPanelSliceStates => store.competitionActionPanel;


import { createSlice } from '@reduxjs/toolkit';
import { Competition } from '@brg/api';

export interface CompetitionActionPanelSliceStates {
    currentCompetition?: Competition;
    legalContestDeferFormPublishCompetitionId?: string | null;
    projectIsValid?: boolean;
    projectErrors?: string[];
}

export const CompetitionActionPanel = createSlice({
    name: 'competitionActionPanel',
    initialState: {
        currentCompetition: {
            competitionId: '',
            requredTagIds: ['5164b991a9d8469389175ceeb86d65b8'],
        },
        // currentCompetition: 'eaf67300718c482cb9e4abfff21f9a4b',
        // // // currentCompetition: null,
        // requiredTagIds: ["dddca0c7066a492a9ea553aca554ab7c",
        //     "2687fadaf0e048ed9925e56052f3010e",
        //     "5164b991a9d8469389175ceeb86d65b8", "47ae888ae5fe4343ad29999d04829b44", "9042e2d03e4e490b8c7effb0d2334cc4", "df140c74barqwe1e3d883a590378812d77"],
        // nominationId: '644035972eb44dcfa1818c464b940c9d',
        projectIsValid: false,
        projectErrors: [],
        legalContestDeferFormPublishCompetitionId: undefined,
    },
    reducers: {
        setCurrentCompetition: (state, action) => {
            state.currentCompetition = action.payload;
        },
        resetCurrentCompetition: (state) => {
            state.currentCompetition = undefined;
            state.legalContestDeferFormPublishCompetitionId = undefined;
        },
        setLegalContestDeferFormPublishCompetitionId: (state, action: { payload: string | undefined | null }) => {
            state.legalContestDeferFormPublishCompetitionId = action.payload ?? undefined;
        },
        setProjectValidity: (state, action) => {
            state.projectIsValid = action.payload.projectIsValid;
            state.projectErrors = action.payload.projectErrors;
        },
        resetProjectValidity: (state) => {
            state.projectIsValid = false;
            state.projectErrors = [];
        },
    },
});

export default CompetitionActionPanel
export const CompetitionActionPanelActions = CompetitionActionPanel.actions
export const ActiveCompetitionSelector = (
    store: { competitionActionPanel: CompetitionActionPanelSliceStates },
): Competition | undefined => store.competitionActionPanel.currentCompetition;

export const LegalContestDeferFormPublishCompetitionIdSelector = (store: {
    competitionActionPanel: CompetitionActionPanelSliceStates;
}): string | undefined | null => store.competitionActionPanel.legalContestDeferFormPublishCompetitionId;
export const ProjectValiditySelector = (store: { competitionActionPanel: CompetitionActionPanelSliceStates }): any => ({
    projectIsValid: store.competitionActionPanel.projectIsValid,
    projectErrors: store.competitionActionPanel.projectErrors,
});
export const CompetitionActionPanelSelector = (store: { competitionActionPanel: CompetitionActionPanelSliceStates }): CompetitionActionPanelSliceStates => store.competitionActionPanel;
